function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import logger from '@formative/browser-logger';
import { FontTypes } from '@formative/types/FontTypes';
import WebFont from 'webfontloader';
var log = logger.child({
  subsystem: 'webfontloader'
});
var maxRetries = 10;
var initialTimeout = 10000;
var _loadFont = function loadFont(config) {
  var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : maxRetries;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : initialTimeout;
  var gotError;
  WebFont.load(_objectSpread(_objectSpread({}, config), {}, {
    timeout: timeout,
    fontinactive: function fontinactive(familyName, fvd) {
      if (gotError) {
        return;
      }
      gotError = true;
      if (retries > 0) {
        log.warn({
          familyName: familyName,
          fvd: fvd,
          retries: retries,
          timeout: timeout
        }, 'Font load failed; retrying');
        _loadFont(config, retries - 1, timeout + 1000);
      } else {
        log.warn({
          familyName: familyName,
          fvd: fvd
        }, 'Font load failed');
      }
    }
  }));
};
export default function loadFonts(fontTypes) {
  if (fontTypes.includes(FontTypes.openSans)) {
    _loadFont({
      google: {
        families: ['Open+Sans:300,400,500,600,700:latin']
      }
    });
  }
  if (fontTypes.includes(FontTypes.openDyslexic)) {
    _loadFont({
      custom: {
        families: ['OpenDyslexicRegular'],
        urls: ['https://cdn.jsdelivr.net/npm/open-dyslexic@1.0.3/open-dyslexic-regular.min.css']
      }
    });
  }
  if (fontTypes.includes(FontTypes.lexend)) {
    _loadFont({
      google: {
        families: ['Lexend:300,400,500,600,700:latin']
      }
    });
  }
  if (fontTypes.includes(FontTypes.frankRuhl)) {
    _loadFont({
      google: {
        families: ['Frank+Ruhl+Libre:300,400,500,600,700:hebrew,latin']
      }
    });
  }
  if (fontTypes.includes(FontTypes.materialIconsOutlined)) {
    _loadFont({
      google: {
        families: ['Material+Icons+Outlined']
      }
    });
  }
  if (fontTypes.includes(FontTypes.nativeEmoji)) {
    _loadFont({
      custom: {
        families: ['native_emoji']
      }
    });
  }
  if (fontTypes.includes(FontTypes.noto)) {
    _loadFont({
      google: {
        families: ['Noto+Serif:300,400,500,600,700:latin']
      }
    });
  }
}